import { render, staticRenderFns } from "./VisitActivityCultural.vue?vue&type=template&id=475dd340"
import script from "./VisitActivityCultural.vue?vue&type=script&lang=js"
export * from "./VisitActivityCultural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports